module.exports = __webpack_public_path__ + "img/jks.9f20461a.png";